// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import iview from "iview";
import api from "./config/api.js";
import { cookie } from "./common/js/public.js";
import tool from "./common/js/tool.js";
import { Tree, Input,DatePicker,Carousel } from 'element-ui';
import config from '@/config/api';
import { bus } from "@/common/js/emit.js";
import ElementUI from 'element-ui';
import './assets/font/iconfont.css'
// import { Tree, Input, Carousel } from 'element-ui';


Vue.use(Tree)
Vue.use(DatePicker)
import reno from "./common/js/renovatoin.js";
import colorPicker from '@/components/color-picker';
import VueDND from 'awe-dnd';
Vue.use(VueDND)
Vue.use(colorPicker)
Vue.use(tool);
Vue.use(reno);
import VueHtml5Editor from "vue-html5-editor";
Vue.prototype.$api = api;
Vue.prototype.$cookie = cookie;
Vue.prototype.$bus = bus;

import "iview/dist/styles/iview.css";
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(iview);
Vue.use(ElementUI)

Vue.prototype.imgApi = config.requestUrl+"/base/file/mgmt/addOneImage"; //图片上传路径
Vue.prototype.flieApi = config.requestUrl+"/base/file/mgmt/upload/file"; //文件上传路径
Vue.prototype.imgBaseUrl = "https://pic.jiangxin-food.com/"; //文件地址


Vue.prototype.imgDelApi =
    config.requestUrl+"/base/file/mgmt/cancelOneImage"; //图片删除路径
Vue.prototype.imgUrl = "https://pic.jiangxin-food.com/"; //图片路径
Vue.prototype.importApi = api.requestUrl + "/secKill/mgmt/importGoods/";
Vue.use(VueHtml5Editor, {
    // 全局组件名称，使用new VueHtml5Editor(options)时该选项无效
    // global component name
    name: "vue-html5-editor",
    // 是否显示模块名称，开启的话会在工具栏的图标后台直接显示名称
    // if set true,will append module name to toolbar after icon
    showModuleName: true,
    // 自定义各个图标的class，默认使用的是font-awesome提供的图标
    // custom icon class of built-in modules,default using font-awesome
    icons: {
        text: "fa fa-pencil",
        color: "fa fa-paint-brush",
        font: "fa fa-font",
        align: "fa fa-align-justify",
        list: "fa fa-list",
        link: "fa fa-chain",
        unlink: "fa fa-chain-broken",
        tabulation: "fa fa-table",
        image: "fa fa-file-image-o",
        hr: "fa fa-minus",
        eraser: "fa fa-eraser",
        undo: "fa-undo fa",
        "full-screen": "fa fa-arrows-alt",
        info: "fa fa-info"
    },
    // 配置图片模块
    // config image module
    image: {
        fieldName: "image",
        // 文件最大体积，单位字节  max file size
        sizeLimit: 512 * 1024,
        // 上传参数,默认把图片转为base64而不上传
        // upload config,default null and convert image to base64
        upload: {
            url: "base/file/mgmt/addOneImage",
            headers: {},
            params: {},
            fieldName: {},
            name: "image"
        },
        // 压缩参数,默认使用localResizeIMG进行压缩,设置为null禁止压缩
        // compression config,default resize image by localResizeIMG (https://github.com/think2011/localResizeIMG)
        // set null to disable compression
        compress: {
            width: 1600,
            height: 1600,
            quality: 80
        },
        // 响应数据处理,最终返回图片链接
        // handle response data，return image url
        uploadHandler(responseText) {
            // console.log(responseText)
            //default accept json data like  {ok:false,msg:"unexpected"} or {ok:true,data:"image url"}
            var json = JSON.parse(responseText);
            if (json.code == 200) {
                // console.log(json.data)
                return config.requestUrl + json.data;
            }
        }
    },
    // 语言，内建的有英文（en-us）和中文（zh-cn）
    //default en-us, en-us and zh-cn are built-in
    language: "zh-cn",
    // 自定义语言
    i18n: {
        //specify your language here
        "zh-cn": {
            align: "对齐方式",
            image: "图片",
            list: "列表",
            link: "链接",
            unlink: "去除链接",
            table: "表格",
            font: "文字",
            "full screen": "全屏",
            text: "排版",
            eraser: "格式清除",
            info: "关于",
            color: "颜色",
            "please enter a url": "请输入地址",
            "create link": "创建链接",
            bold: "加粗",
            italic: "倾斜",
            underline: "下划线",
            "strike through": "删除线",
            subscript: "上标",
            superscript: "下标",
            heading: "标题",
            "font name": "字体",
            "font size": "文字大小",
            "left justify": "左对齐",
            "center justify": "居中",
            "right justify": "右对齐",
            "ordered list": "有序列表",
            "unordered list": "无序列表",
            "fore color": "前景色",
            "background color": "背景色",
            "row count": "行数",
            "column count": "列数",
            save: "确定",
            upload: "选择图片",
            progress: "进度",
            unknown: "未知",
            "please wait": "请稍等",
            error: "错误",
            abort: "中断",
            reset: "重置"
        }
    },
    // 隐藏不想要显示出来的模块
    // the modules you don't want
    hiddenModules: [],
    // 自定义要显示的模块，并控制顺序
    // keep only the modules you want and customize the order.
    // can be used with hiddenModules together
    visibleModules: [
        "text",
        "color",
        "font",
        "align",
        "list",
        "link",
        "unlink",
        "tabulation",
        "image",
        "hr",
        "eraser",
        "undo",
        "full-screen"
    ],
    // 扩展模块，具体可以参考examples或查看源码
    // extended modules
    modules: {
        //omit,reference to source code of build-in modules
    }
});
Vue.directive('requiredNumber',{
    inserted: function (el) {
        el.addEventListener("keypress",function(e){
            e = e || window.event;
            let charcode = typeof e.charCode == 'number' ? e.charCode : e.keyCode;
            let re = /\d/;
            
            if(charcode == 46){
                if(el.value.includes('.')){
                    e.preventDefault();
                }
                return;
            }else if(!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey){
                if(e.preventDefault){
                    e.preventDefault();
                }else{
                    e.returnValue = false;
                }
            }
            if((el.value.indexOf(".")!="-1") && el.value.substring(el.value.indexOf(".")).length>2){
                e.preventDefault();
                return
            }
        });
    }
})
Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    store,
    template: "<App/>",
    components: { App }
});